import { apiClient } from "../apiClient";
export const DOI_TUONG_DAO_TAO_ENDPOINT = "doi-tuong-dao-tao";
export const doiTuongDaoTaoApi = {
  SelectAll: () => apiClient.get(`${DOI_TUONG_DAO_TAO_ENDPOINT}`),
};
